export enum BlockItemPriceType{
    strikethrough,
    real
}

export interface BlockItemPrice{
    type: BlockItemPriceType,
    price: string;
}